import { createAsyncThunk } from '@reduxjs/toolkit';
import { splitCustomFilters } from '@/utils/reports/customFieldFilters';

// A near-copy of src/store/atsReports/common/get-params.js, minus compare and drilldown. Kept
// rather than redirected because fetchEeoVisual is live and the shared builder emits a slightly
// different payload; the split below is what it was missing.
const getParams = ({ timeFrame, group, filters = {} }) => {
  try {
    const { reportFilters, customFilter } = splitCustomFilters(filters || {});
    const params = {
      filter_by: {
        date: {
          from: timeFrame?.from,
        },
        ...reportFilters,
      },
      ...(Object.keys(customFilter).length
        ? { custom_filter: customFilter }
        : {}),
      date_group: timeFrame?.date_group,
    };
    if (timeFrame?.to) {
      params['filter_by']['date']['to'] = timeFrame?.to;
    }
    if (group?.group_by_1) {
      params['group_by_1'] = group?.group_by_1?.id;
    }
    if (group?.group_by_2) {
      params['group_by_2'] = group?.group_by_2?.id;
    }

    return params;
  } catch {
    // Pre-existing swallow: a malformed timeFrame returns undefined params rather than throwing
    // into the thunk. Left as-is; commented only because touching this file surfaces no-empty.
  }
};

const getEeoVisual = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const response = atsHttp.post(`/reports/eeo/visual`, params);
  return response;
};

export const fetchEeoVisual = createAsyncThunk(
  'ats-reports/eeo/visual',
  getEeoVisual
);
